import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/brand";
import UserMenu from "@/components/UserMenu";
import { useAuth } from "@/context/AuthContext";

export const NAV = [
  ["Sports", "/sports"], ["Fantasy", "/fantasy"], ["Live Betting", "/sports/live"], ["Casino", "/casino"],
  ["Live Casino", "/live-casino"], ["Arcade", "/arcade"], ["Promotions", "/promotions"], ["VIP Club", "/vip"],
];

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export default function PublicHeader() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="public-header" className="sticky top-0 z-40 border-b border-cr-line/70 bg-[#080909]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center gap-6 px-5">
        <Logo className="h-14" />
        <nav className="hidden flex-1 items-center justify-center gap-8 lg:flex">
          {NAV.map(([l, to]) => (
            <NavLink key={l} to={to} end data-testid={`nav-${slug(l)}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>{l}</NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-3">
          {user ? <UserMenu /> : (
            <>
              <Link to="/login" data-testid="header-login-btn" className="btn-outline hidden px-6 sm:inline-flex">Login</Link>
              <Link to="/register" data-testid="header-register-btn" className="btn-gold px-6">Register</Link>
            </>
          )}
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger data-testid="mobile-menu-btn" aria-label="Open menu" className="rounded-md p-2 text-cr-ink lg:hidden"><Menu className="h-6 w-6" /></SheetTrigger>
            <SheetContent side="left" className="w-72 border-cr-line bg-cr-bg text-cr-ink">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <Logo className="h-12" />
              <nav className="mt-8 flex flex-col gap-1">
                {[["Home", "/"], ...NAV].map(([l, to]) => (
                  <NavLink key={l} to={to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-${slug(l)}`} className={({ isActive }) => `side-link ${isActive ? "active" : ""}`}>{l}</NavLink>
                ))}
              </nav>
              {!user && (
                <div className="mt-8 grid gap-3">
                  <Link to="/login" onClick={() => setOpen(false)} data-testid="mobile-login-btn" className="btn-outline">Login</Link>
                  <Link to="/register" onClick={() => setOpen(false)} data-testid="mobile-register-btn" className="btn-gold">Register</Link>
                </div>
              )}
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
